export default function updateSelectedNodesCount(prevNodesCount, updatedNode) {
  return updatedNode.isSelected ? prevNodesCount + 1 : prevNodesCount - 1
}
